export default `
  query getOrgUsageForOwner($orgId: ID!, $from: String!, $to: String!, $nextToken: String) {
    getOrgUsageForOwner(orgId: $orgId, from: $from, to: $to, nextToken: $nextToken) {
      items {
        id
        model
        provider
        userId
        useCase
        projectId
        totalTokens
        status
        timestamp
        day
      }
      nextToken
    }
  }
`
